import React from "react";

export default function Sidebar({ categories, selectedCategory, setSelectedCategory }) {
  return (
    <>
      {/* ✅ Mobile Dropdown (visible only on small screens) */}
      <div className="d-block d-md-none mb-3">
        <select
          className="form-select camelcase"
          value={selectedCategory}
          onChange={(e) => setSelectedCategory(e.target.value)}
        >
          {categories.map((cat) => (
            <option key={cat} value={cat}>
              {cat}
            </option>
          ))}
        </select>
      </div>

      {/* ✅ Desktop Sidebar (hidden on small screens) */}
      <div className="d-none d-md-block list-group">
        {categories.map((cat) => (
          <button
            key={cat}
            className={`list-group-item list-group-item-action ${
              selectedCategory === cat ? "active" : ""
            }`}
            onClick={() => setSelectedCategory(cat)}
          >
            {cat}
            {selectedCategory === cat && (
              <span className="float-end">✓</span>
            )}
          </button>
        ))}
      </div>
    </>
  );
}